/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import Icon from '../shapes/Icon'

const iconWrapperSize = '3rem'

export const inputStyle = `
	position: relative;
	display: block;
	width: 100%;
	
	& > .input {
		text-transform: none;
		min-height: 2.39rem;
		display: flex;
		align-items: center;
		width: 100%;
		border-radius: 5px;
		border: 1px solid ${COLORS.light5};
		background-color: transparent;
		position: relative;
		box-shadow: none;
		-webkit-appearance: none;
		padding: 0.6rem 0.75rem;
	}


	& > input:focus {
		border-color: ${COLORS.blue};
		outline: none;
	}

	& > .rightContent,
	& > .leftContent {
		position: absolute;
		bottom: 0;
		top: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: ${iconWrapperSize};
		z-index: 9;
	}
	& > .rightContent {
		right: 0;
	}
`

export const useBasicInputStyle = ({
  leftPadding,
  iconLeft,
  iconRight,
  noBorder,
  disabled,
  small,
  xsmall,
  inputOnTop,
  align,
  errorBorder,
  minWidth,
  defaultRadialBorder
}) => {
  return css`
    ${inputStyle}
    ${minWidth ? `& > .input {min-width: ${minWidth};}` : ''}
    ${leftPadding ? `& > .input {padding-left: ${leftPadding};}` : ''}
    ${iconLeft ? `& > .input {padding-left: ${iconWrapperSize};}` : ''}
		${iconRight ? `& > .input {padding-right: ${iconWrapperSize};}` : ''}
		${align
      ? `
					& > .input {
						text-align: ${align};
					}
				`
      : ''}
		${noBorder
      ? `
			& > .input {
				border: none;
				border-radius: 0;
			}
		`
      : ''}
	  ${errorBorder
      ? `
			  & > .input {
				  border: 1px solid ${COLORS.red};
				  ${defaultRadialBorder ? '' : 'border-radius: 0;'}
			  }
		  `
      : ''}
		${disabled
      ? `
			opacity: 0.5;
			background-color: ${COLORS.light2};
		`
      : ''}

		${small
      ? `
			& > .input {
				min-height: 1.5rem;
			}
		`
      : ''}

		${xsmall
      ? `
			& > .input {
				min-height: 1.5rem;
				padding: 0;
				padding: .3rem 0.75rem;
			}
		`
      : ''}

		${inputOnTop
      ? `
			& > .rightContent, & > .leftContent {
				z-index: 0;
			}
			& > .input {
				position: aboslute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				z-index: 10;
			}
		`
      : ''}
  `
}

const InputWrapper = ({
  children,
  disabled,
  iconRight,
  iconRightAction,
  iconLeft,
  leftContent,
  leftPadding,
  noBorder,
  iconSize,
  small,
  xsmall,
  inputOnTop,
  align,
  iconColor,
  errorBorder,
  defaultRadialBorder,
  minWidth,
  keepValueWhenDisabled
}) => {
  const style = useBasicInputStyle({
    inputOnTop,
    leftPadding,
    iconLeft,
    iconRight,
    noBorder,
    disabled,
    small,
    xsmall,
    align,
    errorBorder,
    defaultRadialBorder,
    minWidth
  })

  return (
    <div css={style}>
      {!!iconLeft && (
        <div className="leftContent">
          <Icon name={iconLeft} color={COLORS.dark3} size={iconSize} />
        </div>
      )}
      {leftContent && <div className="leftContent">{leftContent}</div>}
      {keepValueWhenDisabled ? children : !disabled ? children : <div className="input" />}
      {iconRight && (
        <div className="rightContent">
          <Icon name={iconRight} color={iconColor || COLORS.dark3} onClick={iconRightAction} size={iconSize} />
        </div>
      )}
    </div>
  )
}

export default InputWrapper
